import { Permission, DeliveryNoteDTO } from 'core/api';
import { Command } from 'pos/common';
import { Preconditions } from 'core/infrastructure-next';
import { sendDocumentEmail } from 'pos/modules/helpers/document-emailing';
import { DeliveryNoteFacade } from 'pos/facades';

declare global {
	interface CommandType {
		sendDeliveryNoteByEmail: (note: DeliveryNoteDTO) => Promise<Result>
	}
}

Command.register('sendDeliveryNoteByEmail', Preconditions.and(Preconditions.ensure(Permission.DeliveryNote_SendEmail), Preconditions.ensureIsNotLite), async (note: DeliveryNoteDTO): Promise<Result> => {
	const options = await DeliveryNoteFacade.getEmailOptions(note.Id);
	return sendDocumentEmail({
		getDefaultOptions: () => options,
		send: DeliveryNoteFacade.sendEmail
	});
});

